import { render, staticRenderFns } from "./add-tian-map.vue?vue&type=template&id=b5170e42&scoped=true&"
import script from "./add-tian-map.vue?vue&type=script&lang=js&"
export * from "./add-tian-map.vue?vue&type=script&lang=js&"
import style0 from "./add-tian-map.vue?vue&type=style&index=0&id=b5170e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5170e42",
  null
  
)

export default component.exports